<div class="container">
  <div class="icon">&#10006;</div>
  <h1>Payment Failed</h1>
  <p>Unfortunately, we were unable to process your payment.</p>
  <!--<div class="error-details">
            <p><strong>Reason:</strong> Insufficient funds</p>
            <p>Please try a different payment method or check your card details.</p>
        </div>
        <div class="actions">
            <a href="#" class="button">Try Again</a>
            <a href="#" class="button">Update Payment Method</a>
        </div>-->
  <!--<div class="contact-support">
            <p>If you continue to have issues, please <a href="#">contact support</a>.</p>
        </div>-->
</div>
